import API from "../../../../../global/api";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from "moment";
import { isEmpty } from "lodash";
import { PDFHeader, showErrorAlert } from "../../../../../global/globalFunctions";
import PaymentReceivedStamp from '../../../../../Images/PaymentReceivedStamp.jpg';


export const requestAddConstructionOrderPayment = () => {
    return {
        type: "REQUEST_ADD_CONSTRUCTION_ORDER_PAYMENT",
    };
};
export const successAddConstructionOrderPayment = (data) => {
    return {
        type: "SUCCESS_ADD_CONSTRUCTION_ORDER_PAYMENT",
        payload: data,
    };
};
export const errorAddConstructionOrderPayment = () => {
    return {
        type: "ERROR_ADD_CONSTRUCTION_ORDER_PAYMENT",
    };
};
export const AddConstructionOrderPaymentApi = (payload, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddConstructionOrderPayment());
        API.post(`/construction/add-order-payment`, payload)
            .then((res) => {
                dispatch(successAddConstructionOrderPayment(res.data));
                showSuccessAlert(res.data.message);
            }).catch((error) => {
                dispatch(errorAddConstructionOrderPayment());
                showErrorAlert(error.response.data.message || "Something went wrong");
            });
    };
};


export const resetConstructionOrderPaymentData = () => {
    return {
        type: "RESET_CONSTRUCTION_ORDER_PAYMENT_DATA",
    };
};


export const requestGetConstructionOrderPayment = () => {
    return {
        type: "REQUEST_GET_CONSTRUCTION_ORDER_PAYMENT",
    };
};
export const successGetConstructionOrderPayment = (response) => {
    return {
        type: "SUCCESS_GET_CONSTRUCTION_ORDER_PAYMENT",
        payload: response,
    };
};
export const errorGetConstructionOrderPayment = () => {
    return {
        type: "ERROR_GET_CONSTRUCTION_ORDER_PAYMENT",
    };
};
export const GetConstructionOrderPaymentApi = (orderId) => {
    return (dispatch) => {
        dispatch(requestGetConstructionOrderPayment());
        API.get(`/construction/get-order-payments${orderId ? `?orderId=${orderId}` : ''}`)
            .then((res) => {
                dispatch(successGetConstructionOrderPayment(res.data));
            }).catch((error) => {
                dispatch(errorGetConstructionOrderPayment());
            });
    };
};


export const DeleteRequestConstructionOrderPayment = () => {
    return {
        type: "DELETE_REQUEST_CONSTRUCTION_ORDER_PAYMENT",
    };
};
export const DeleteSuccessConstructionOrderPayment = (paymentId) => {
    return {
        type: "DELETE_SUCCESS_CONSTRUCTION_ORDER_PAYMENT",
        paymentId: paymentId,
    };
};
export const DeleteErrorConstructionOrderPayment = () => {
    return {
        type: "DELETE_ERROR_CONSTRUCTION_ORDER_PAYMENT",
    };
};
export const DeleteConstructionOrderPaymentApi = (paymentId) => {
    return (dispatch) => {
        dispatch(DeleteRequestConstructionOrderPayment());
        API.delete(`/construction/delete-order-payment/${paymentId}`)
            .then((res) => {
                dispatch(DeleteSuccessConstructionOrderPayment(paymentId));
            }).catch((error) => {
                dispatch(DeleteErrorConstructionOrderPayment());
            });
    };
};


export const GeneratePaymentReceiptPDF = (data) => {
    return (dispatch) => {
        const unit = "pt";
        const size = "A4";
        const orientation = "p";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Payment Receipt");


        doc.setFontSize(12);
        doc.setFont("Times New Roman", "normal")
        doc.text(`Receipt No: ${data.sequenceNumber}`, 50, 130, 0, 20);
        doc.text(`Order No: ${data?.orderDetails?.sequenceNumber || '-'}`, 50, 145, 0, 20);
        doc.text(`Customer Name: ${data?.orderDetails?.customerName || '-'}`, 50, 160, 0, 20);
        doc.text(`Payment Date: ${moment(data?.date).format('DD-MM-YYYY')}`, 50, 175, 0, 20);
        doc.text(`Payment Mode: ${data?.paymentMode || 'Cash'}`, 50, 190, 0, 20);
        doc.text(`Received By: ${data?.userDetails?.userName || '-'}`, 50, 205, 0, 20);
        doc.addImage(PaymentReceivedStamp, "JPG", 330, 120, 90, 80);


        const paymentHeaders = [[
            "Description",
            "Amount"
        ]];
        const paymentBody = [
            [
                { content: "Order Amount", styles: { halign: "left" } },
                { content: Number(data?.orderDetails?.sellingPrice || 0).toLocaleString(), styles: { halign: "right" } }
            ],
            // [
            //     { content: "Previous Received", styles: { halign: "left" } },
            //     { content: Number(data.previousReceived || 0).toLocaleString(), styles: { halign: "right" } }
            // ],
            [
                { content: "Payment Received", styles: { halign: "left", fontStyle: "bold" } },
                { content: Number(data.payment || 0).toLocaleString(), styles: { halign: "right", fontStyle: "bold" } }
            ],
            // [
            //     { content: "Remaining Balance", styles: { halign: "left" } },
            //     { content: Number(data.remainingBalance || 0).toLocaleString(), styles: { halign: "right" } }
            // ],
            [
                { content: "Description", styles: { halign: "left" } },
                { content: data.description || "-", styles: { halign: "right" } }
            ],
        ];
        let paymentTable = {
            startY: 230,
            startX: 50,
            head: paymentHeaders,
            body: paymentBody,
            theme: "grid",
            styles: {
                fontSize: 10,
                cellPadding: 6
            },
            headStyles: {
                fillColor: "#2980ba",
                halign: "center",
                fontStyle: "bold"
            },
        };
        doc.autoTable(paymentTable);


        doc.setProperties({ title: `Payment Receipt` });
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
    };
};


export const GenerateOrderPaymentLedgerPDF = (orderId, orderData) => {
    return (dispatch) => {
        API.get(`/construction/get-order-payments?orderId=${orderId}`)
            .then((res) => {
                const ledgerData = res.data.data || [];
                const orderAmount = Number(orderData?.sellingPrice || 0);

                const sortedData = [...ledgerData].sort((a, b) => new Date(a.date) - new Date(b.date));
                let cumulative = 0;
                sortedData.forEach((item) => {
                    item.previousReceived = cumulative;
                    cumulative = Math.round((cumulative + Number(item.payment || 0)) * 100) / 100;
                    item.closingBalance = cumulative;
                });
                const totalReceived = cumulative;
                const remainingBalance = Math.round((orderAmount - totalReceived) * 100) / 100;

                const unit = "pt";
                const size = "A4";
                const orientation = "l";
                const doc = new jsPDF(orientation, unit, size);
                PDFHeader(doc, "Order Payment Ledger");

                doc.setFontSize(11);
                doc.setFont("Times New Roman", "normal");
                doc.text(`Order No: ${orderData?.sequenceNumber || '-'}`, 40, 130);
                doc.text(`Customer Name: ${orderData?.customerDetails?.name || '-'}`, 40, 145);
                doc.text(`Order Amount: ${orderAmount.toLocaleString()}`, 40, 160);
                doc.text(`Total Received: ${Number(totalReceived).toLocaleString()}`, 250, 145);
                doc.text(`Remaining Balance: ${remainingBalance.toLocaleString()}`, 250, 160);

                const headers = [[
                    "S.No",
                    "Date",
                    "Payment",
                    "Payment Mode",
                    "Description",
                    // "Previous Received",
                    "Closing Balance",
                    "Created By",
                ]];
                const body = isEmpty(sortedData) ? [] : sortedData.map((elt) => [
                    elt.sequenceNumber,
                    moment(elt.date).format("DD-MM-YYYY"),
                    Number(elt.payment || 0).toLocaleString(),
                    elt.paymentMode,
                    elt.description || "-",
                    // Number(elt.previousReceived || 0).toLocaleString(),
                    Number(elt.closingBalance || 0).toLocaleString(),
                    elt.userDetails?.userName,
                ]);

                doc.autoTable({
                    startY: 180,
                    startX: 40,
                    head: headers,
                    body: body,
                    theme: "grid",
                    styles: { fontSize: 9, cellPadding: 6 },
                    headStyles: { fillColor: "#2980ba", halign: "center", fontStyle: "bold" },
                });

                doc.setProperties({ title: `Order Payment Ledger` });
                doc.output("dataurlnewwindow");
            }).catch((error) => {
                showErrorAlert(error?.response?.data?.message || "Something went wrong");
            });
    };
};
